<template>
    <div class="block_content ppv2-text-black">
        <X class="icon_close cursor-pointer" @click="exit()" />
        <div class="content" :style="{ gap: normalizeSizeVertical(85), paddingRight: 16 }">
            <div class="ppv2-text-black poppinsLight ppv2-text-center" :style="{ fontSize: normalizeFontSize(34) }">
                🎉<br />{{ $t('experience.success.title') }}
            </div>
            <div class="content_info_url">
                <div class="bloc_info ppv2-text-black">
                    <span class="ppv2-text-black poppinsRegular" :style="{ fontSize: normalizeFontSize(14) }">{{
                        $t('experience.success.url')
                    }}</span>
                    <div class="bloc_input ppv2-flex ppv2-items-center ppv2-justify-between ppv2-gap-2">
                        <span
                            class="poppinsRegular ppv2-text-[#A0AEC0] ppv2-truncate"
                            :style="{ fontSize: normalizeFontSize(15) }"
                        >
                            {{ link }}
                        </span>
                        <div class="ppv2-relative ppv2-flex ppv2-items-center">
                            <Copy
                                class="pos_copy ppv2-text-[#A0AEC0] hover:ppv2-text-[#7D2DBD] ppv2-transition-colors"
                                @click="copy_link()"
                                @mouseenter="showTooltip = true"
                                @mouseleave="showTooltip = false"
                                :size="15"
                            />
                            <!-- Tooltip Badge -->
                            <transition name="fade">
                                <div
                                    v-if="showTooltip || isCopied"
                                    class="copyBadge poppinsRegular"
                                    :class="{ copied: isCopied }"
                                >
                                    {{ isCopied ? $t('common.copied') : $t('common.copy_link') }}
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Plus, Copy, X } from 'lucide-vue'
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeSizeVertical from '../../../../utils/normalizeSizeVertical'
import confetti from 'canvas-confetti'
import normalizeFontSize from '../../../../utils/normalizeFontSize'
export default {
    components: { Plus, Copy, X },
    props: {
        prestation: { type: Object, required: false },
        url_front_reservation: { type: String, default: '' },
        activeStep: { type: Number, default: 1 },
    },
    data() {
        return {
            showTooltip: false,
            isCopied: false,
        }
    },
    mounted() {
        if (this.activeStep === 8) {
            this.fireConfetti()
        }
    },
    methods: {
        normalizeFontSize,
        normalizeSizeVertical,
        normalizeSize,
        copy_link() {
            navigator.clipboard
                .writeText(this.link)
                .then(() => {
                    this.isCopied = true
                    setTimeout(() => {
                        this.isCopied = false
                    }, 3000)
                })
                .catch((err) => {
                    console.error('Erreur lors de la copie :', err)
                })
        },
        fireConfetti() {
            const duration = 3 * 1000
            const animationEnd = Date.now() + duration
            const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 }

            const randomInRange = (min, max) => Math.random() * (max - min) + min

            const interval = setInterval(() => {
                const timeLeft = animationEnd - Date.now()

                if (timeLeft <= 0) {
                    return clearInterval(interval)
                }

                const particleCount = 50 * (timeLeft / duration)
                // since particles fall down, start a bit higher than random
                confetti({
                    ...defaults,
                    particleCount,
                    origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
                })
                confetti({
                    ...defaults,
                    particleCount,
                    origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
                })
            }, 250)
        },
        exit() {
            window.location.href = '/back-office/v3/experience'
        },
    },
    computed: {
        link() {
            const base = this.url_front_reservation ? this.url_front_reservation + '/' : ''
            if (this.prestation) {
                return `${base}${this.prestation.slug}`
            }
            return base
        },
    },
}
</script>
<style scoped>
.block_content {
    height: 75vh;
    opacity: 1;
}

.icon_close {
    width: 29px;
    height: 29px;
    opacity: 1;
    position: absolute;
    top: 63px;
    right: 48px;
}

.content {
    display: flex;
    flex-direction: column;
    /* stack text and button vertically */
    align-items: center;
    /* center horizontally */
    justify-content: center;
    /* center vertically */
    text-align: center;
    height: 100%;
}

.content_info_url {
    width: 100%;
    opacity: 1;
    border-radius: 12px;
    /*background: #ababab0d;*/
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    /* vertical center */
}

.label_link_font {
    font-family: 'Poppins SemiBold', sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: clamp(12px, 0.729545vw, 16px);
    line-height: 160%;
    letter-spacing: 0px;
    color: #ffffff;
}

.bloc_input {
    width: 100%;
    height: 40px;
    border-radius: 12px;
    color: #ffffff;
    border: 1px solid #545595;
    padding: 6px 8px;
}

.bloc_info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    gap: 13px;
}

.size_height {
    height: 16%;
}

.pos_copy {
    position: relative;
    cursor: pointer;
}

.copyBadge {
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 12px;
    background-color: #1a1f37;
    color: white;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 13px;
    white-space: nowrap;
    z-index: 100;
    box-shadow:
        0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.06);

    &::before {
        content: '';
        position: absolute;
        right: 100%;
        top: 50%;
        transform: translateY(-50%);
        border: 6px solid transparent;
        border-right-color: #1a1f37;
    }
}

.copyBadge.copied {
    background-color: #10b981;
    &::before {
        border-right-color: #10b981;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition:
        opacity 0.3s,
        transform 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
}

.pos_text {
    float: left;
    left: 2%;
    position: relative;
    top: 6px;
}
</style>
